import accounting from 'accounting'
import isDecimal from './isDecimal'

const FormatMoney = (value = 0, thousand = ',', decimal = '.', precision = 2) => {
  let formatted = accounting.formatMoney(value, { format: '%v', thousand, decimal, precision: isDecimal(value) ? precision : 0 }) 
  return formatted
}

export default FormatMoney



// WEBPACK FOOTER //
// ./src/Utils/FormatMoney.js